import { PaymentGate } from "@/components/PaymentGate";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const PaymentGatePage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // This component just wraps PaymentGate and redirects to dashboard if paid
  }, []);

  return (
    <PaymentGate>
      {/* This will never render as PaymentGate handles the redirect */}
      <div />
    </PaymentGate>
  );
};

export default PaymentGatePage;